import { Theme } from "@mui/material";

import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";

/**
 * Avatar background / role chip colour per staff role (Keycloak role).
 * Supervisor stands out in orange; all other roles use the neutral colour.
 */
export function getStaffRoleColor(theme: Theme, role: UserPermission): string {
  switch (role) {
    case UserPermission.Supervisor:
      return theme.palette.secondary.main;
    default:
      return theme.palette.action.active;
  }
}
